import {
  AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding,
  Inject, Input, OnChanges, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild, ViewEncapsulation
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { fromEvent, Subscription } from 'rxjs';

import {
  BrandsEnum, DeviceService, IconSizeEnum, IReparability, SdHtmlComponent, SdIconComponent, SdLinkComponent
} from '@seb/web-design-system/core';

import { ReparabilityThemesEnum } from './reparability.enum';

@Component({
  selector: 'sd-reparability',
  templateUrl: './reparability.component.html',
  styleUrls: ['./reparability.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdIconComponent,
    SdLinkComponent,
    SdHtmlComponent,
    TranslateModule
  ]
})
export class SdReparabilityComponent implements OnChanges, AfterViewInit, OnInit, OnDestroy {
  @Input()
  brand: BrandsEnum;

  @Input()
  reparabilityData: IReparability;

  @Input()
  showInfo = true;

  @Input()
  isSmall: boolean;

  @ViewChild('reparabilityLink', { read: ElementRef })
  reparabilityLink: ElementRef;

  @Output()
  repairabilityInfoClick = new EventEmitter<void>();

  @Output()
  reparabilityLinkClick = new EventEmitter<void>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.theme ? 'is-theme-' + this.theme : '',
      this.isSmall ? 'is-small' : '',
      this.showInfo ? 'has-show-info' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  subscriptions = new Subscription();
  theme: ReparabilityThemesEnum;
  iconSize = IconSizeEnum;
  stringValue: string;
  isDevice$: boolean;
  isMobile$: boolean;

  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.deviceService.isDevice.subscribe((x) => {
        this.isDevice$ = x;
        this.cdRef.markForCheck();
      })
    );
    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile$ = x;
        this.cdRef.markForCheck();
      })
    );
  }

  ngAfterViewInit(): void {
    this.manageTranslationLink();
  }

  ngOnChanges(): void {
    const index = this.reparabilityData.index;

    this.stringValue = index.toString().replace('.', ',');

    if (index < 2) {
      this.theme = ReparabilityThemesEnum.red;
    } else if (index >= 2 && index < 4) {
      this.theme = ReparabilityThemesEnum.orange;
    } else if (index >= 4 && index < 6) {
      this.theme = ReparabilityThemesEnum.yellow;
    } else if (index >= 6 && index < 8) {
      this.theme = ReparabilityThemesEnum.green;
    } else if (index >= 8 && index <= 10) {
      this.theme = ReparabilityThemesEnum.darkGreen;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onRepairabilityInfoClick(): void {
    this.repairabilityInfoClick.emit();
  }

  private manageTranslationLink(): void {
    if (this.reparabilityLink && isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        const links = this.reparabilityLink.nativeElement.getElementsByTagName('a');
        for (const link of links) {
          this.subscriptions.add(
            fromEvent(link, 'click').subscribe(() => {
              this.reparabilityLinkClick.emit();
            }),
          );
        }
      }, 500);
    }
  }
}
